import React, { useCallback } from 'react';
import { RouteComponentProps } from 'react-router';

import useUser from 'core/hooks/useUser';
import { UserFormSchema } from 'core/schemas/userForm';
import { FormSubmitHandler } from 'Elements/Form';

import UserForm from './UserPage/UserForm';
import UserPage from './UserPage/UserPage';

type Props = RouteComponentProps<{ id: string }>;

export default function UserDetail({ match }: Props) {
  const { user, update } = useUser(match.params.id);

  const onSubmit: FormSubmitHandler<UserFormSchema> = useCallback(
    (values, form) => {
      return update(values.user).catch(errors =>
        form.setErrors({ user: errors })
      );
    },
    [update]
  );

  return (
    <UserForm onSubmit={onSubmit} user={user}>
      <UserPage
        title={user ? user.full_name : '–'}
        subtitle={user ? `${user.email}` : '–'}
      />
    </UserForm>
  );
}
